<template>

  <div class="intro center">     
    <div class="profilePic"></div>  
    <h2 class="lead center">Hey there!</h2>            
    <p class="text">
      I am Bibhuti Poudyal. This is my portfolio and a blog.
      <br><br>
      View my <router-link to="/resume" class="link">resume</router-link>
      and<router-link to="/projects" class="link"> projects</router-link>
      <br>
      Read my answers on <a href="https://www.quora.com/profile/Bibhuti-Poudyal" class="link">Quora</a>
      <br>
      Follow me on <a href="https://twitter.com/bibhuti_coder" class="link">Twitter</a>
      or <a href="https://github.com/bibhuticoder" class="link">Github</a>
      <br>
      Email me at <a href="mailto:bibhutipd@gmail.com" class="link">bibhutipd@gmail.com</a>              
    </p>
    <br> 
    <SocialHandlers />
    <div v-on:click="scrollee">
      <i class="fas fa-chevron-down" id="down"></i> 
    </div> 
  </div>
 
</template>

<script>
import SocialHandlers from '@/components/SocialHandlers'
export default {
  components: {SocialHandlers},
  name: 'Intro',
  data(){
    return{
    }
  },
  methods: {
    scrollee(){
      document.querySelector('.blogs').scrollIntoView({ 
        behavior: 'smooth' 
      });
    }
  },
  computed:{},
  created(){}
}
</script>

<style scoped>
  
  .intro{
    width: 100vw;
    height: calc(100vh - 50px);
    margin-top: 50px;
    padding: 12px;
    font-weight: 500;
    font-family: Segoe UI !important;
  }

  .profilePic {    
    margin: 0 auto;
    margin-top: 5px;
    margin-bottom: 10px;
    height: 100px;
    width: 100px;
    border-radius: 100%;
    background-image: url('https://qph.ec.quoracdn.net/main-thumb-90418459-200-whsmopziphktwwyulynuhdrojnwtpzsu.jpeg');
    background-size: cover;
    background-position: center;
    transform: rotate(-2deg);
  }

  .text{
    font-size: 1.2em;
    font-weight: 400;
  }

  .headline{
    color: #212121;
    border-bottom-style: solid;
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    font-weight: 600;    
  }

  #down{
    font-size: 100px;
    margin-top: 50px;
    color: lightgray;
    cursor: pointer;
    transition: color 0.5s;
  }

  #down:hover{
    color: gray;
  }


</style>



// WEBPACK FOOTER //
// src/components/Intro.vue